export const SET_TRANSLATIONS = "SET_TRANSLATIONS";
export const SET_CURRENT_LOCALE = "SET_CURRENT_LOCALE";
